import React from 'react'
import Header from '../components/Header/Header'
import LeaveStatus from '../components/leave/LeaveStatus'
import LeaveHome from '../components/leave/LeaveHome'

function LeaveMain() {
  return (
    <div>
        <Header/>
        <LeaveHome/>
    </div>
  )
}

export default LeaveMain